module.exports = __webpack_public_path__ + "static/img/threePhase_content_bg1.b6a8bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/threePhase_content_bg1.png
// module id = AJeX
// module chunks = 1